import { client } from './client';

const API_ENDPOINT = process.env.REACT_APP_MS_CUSTOM_LIST_IMPORTS;

class ImportListDataService {
  static sendFile(path = '', params) {
    const formData = new FormData();
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((item) => formData.append(`${key}[]`, item));
      } else if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    })
    return client({
      method: 'POST',
      url: path,
      baseURL: API_ENDPOINT,
      data: formData,
      headers: { 'Content-Type': undefined },
    });
  }
}

export { ImportListDataService }